import React, { Suspense, lazy } from 'react';
import Icon from '../../components/common/Icon.react';

const Loading = () => (
  <button className="btn btn-icon mb0 bl-0 br-0" disabled type="button">
    <Icon icon="download" />
  </button>
);

const UsersAdminExportConfig = lazy(() =>
  import(/* webpackChunkName: "UsersAdminExportConfig" */ '../../components/users/UsersAdminExportConfig')
);

export default function UsersAdminExportConfigComponent({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <UsersAdminExportConfig {...props} />
    </Suspense>
  );
}
